﻿import { FC } from "react";
import { AbsoluteCenterProps, Box, Center, Spinner, VStack, Text } from "@chakra-ui/react";

type LoadingWidgetProps = AbsoluteCenterProps & { size?: string; color?: string; text?: string };

/**
 * Use this component anytime you are waiting for a specific component to load, and supply text to the user explaining what it is waiting for.
 *
 * ```
 * <WidgetLoading text={"Loading this widget..."}/>
 * ```
 *
 * @param text
 * @param size
 * @param color
 */
export const WidgetLoading: FC<LoadingWidgetProps> = ({ size, color, text, ...rest }) => (
    <Center height={"100%"} {...rest}>
        <VStack>
            <Box>
                <Spinner color={color || "var(--chakra-colors-blue-700)"} size={size || "md"} thickness={"3px"} />
            </Box>
            {text && (
                <Box>
                    <Text>{text}</Text>
                </Box>
            )}
        </VStack>
    </Center>
);

export const LoadingWidget = WidgetLoading;
